export interface IProfileItem {
  icon: string;
  title: string;
  href?: string;
  needAuth: boolean;
  onClick?: any;
  name?: string;
  subTitle?: string;
}

export const profileItems: IProfileItem[] = [
  {
    icon: '/profile-menu/user-icon.svg',
    title: 'MY_DETAILS',
    href: '/profile',
    needAuth: true,
  },
  {
    icon: '/profile-menu/myCards.svg',
    title: 'myCards',
    href: '/cards',
    needAuth: true,
  },
  {
    icon: '/icons/coupons.svg',
    title: 'myPromocodes',
    href: '/promo',
    needAuth: true,
  },
  {
    icon: '/profile-menu/heart-icon.svg',
    title: 'FAVORITES',
    href: '/favourites',
    needAuth: true,
  },
  {
    icon: '/profile-menu/question-mark-icon.svg',
    title: 'SUPPORT',
    name: 'support',
    subTitle: 'NEED_HELP',
    needAuth: false,
  },
  {
    icon: '/profile-menu/info-icon.svg',
    title: 'USER_AGREEMENT',
    href: '/agreement',
    needAuth: false,
  },
  {
    icon: '/profile-menu/info-icon.svg',
    title: 'DELIVERY_TERMS',
    href: '/delivery-details',
    needAuth: false,
  },
  {
    icon: '/profile-menu/logout.svg',
    title: 'LOGOUT',
    name: 'logout',
    needAuth: true,
  },
];
